module.exports = __webpack_public_path__ + "img/img8.6dd4189b.svg";